import { USER_ENVIRONMENTS } from 'constants';
import { IS_SANDBOX_ENV } from 'helper/constant';

const { SANDBOX, SANDBOX_DEV, PRODUCTION, CURRENT_ENV, STAGING, ALPHA } = USER_ENVIRONMENTS;

const LIVE_SWITCH_TARGET = CURRENT_ENV === PRODUCTION ? SANDBOX : SANDBOX_DEV;

export const ENV_LABEL = IS_SANDBOX_ENV ? 'Sandbox' : 'Production';

export const SWITCH_TARGET = IS_SANDBOX_ENV ? PRODUCTION : LIVE_SWITCH_TARGET;

// These live envs can only switch once the company has a sandbox admin.
export const NEEDS_SANDBOX_ADMIN = [PRODUCTION, STAGING, ALPHA].includes(CURRENT_ENV);

export const ENV_OPTIONS = [
    { label: 'Production', description: 'Live checks on your real customers', isSandbox: false },
    { label: 'Sandbox', description: 'Test workflows with sample data', isSandbox: true },
];

export const SANDBOX_ON_REQUEST = 'A separate test environment, available on request';
